export const ActionTypes = {
  SET_VOUCHERS: 'SET_VOUCHERS'
};
